import React, {ReactElement} from "react";

interface Props {
  cards: ReactElement[]
}

export function ResponsiveCardMasonry({cards}: Props) {
  const cardsPerColumn = Math.ceil(cards.length / 4);
  const columns = Array.from({length: 3}, (_, columnIndex) => {
    return cards.slice(columnIndex * cardsPerColumn, (columnIndex + 1) * cardsPerColumn);
  });

  return <div className={"row"}>
    {columns.map((column, index) => {
      if(column.length === 0) {
        return <React.Fragment key={index}/>;
      }
      return <div className={`col-md-4 col-sm-6 col-12`} key={index}>
        {column.map((card, cardIndex) => (
          <div key={cardIndex} className="card">{card}</div>
        ))}
      </div>
    })}
  </div>
}